import businessDayString from './businessDay';

const getDefaultDate = () => {
    const [month, day, year] = businessDayString().split('-');
    return `${year}-${month}-${day}`;
};

export default getDefaultDate;
